<template>
  <validation-observer>
    <v-card
      flat
      max-width="480"
      class="neg-margin mx-auto px-9 px-md-0 pt-12 py-lg-0 responsive-bg"
    >
      <v-card-title
        primary-title
        class="step-title pa-0 pa-md-10 font-weight-bold mb-12 justify-md-center headline"
      >
        Step 2
        <abbr class="mobile-hypen">-</abbr>
        <span class="d-md-none">Tell us about your business</span>
        <span class="d-none d-md-block">About your business</span>
        <v-progress-linear indeterminate v-if="request.submitting" />
      </v-card-title>
      <div class="form-wrapper register">
        <div class="mb-5 mb-md-12">
          <ValidationProvider
            name="company_name"
            rules="required"
            v-slot="{ errors }"
          >
            <v-text-field
              name="business_name"
              :error-messages="errors"
              v-model="request.business.name"
              label="Company Name"
              required
            />
          </ValidationProvider>

          <ValidationProvider name="business_website" v-slot="{ errors }">
            <v-text-field
              name="business_website"
              website="business_website"
              :error-messages="errors"
              v-model="request.business.website"
              label="Company Website"
            />
          </ValidationProvider>

          <LocationField
            name="business_location"
            v-model="request.business.location"
            :required="true"
          />
          <label class="d-none d-md-block mx-5 mx-md-0 mt-6 mb-8 grey--text">
            Type of trips (Select all that apply)
          </label>

          <v-select
            v-model="request.business.trip_ids"
            :items="trips"
            item-value="id"
            item-text="name"
            class="d-block d-md-none"
            :menu-props="{ maxHeight: '400', contentClass: 'notranslate' }"
            label="Type of trips (Select all that apply)"
            multiple
            persistent-hint
          />

          <v-chip
            v-for="(trip, index) in trips"
            :key="index"
            :class="
              request.business.trip_ids.includes(trip.id)
                ? 'black white--text'
                : ''
            "
            :outlined="!request.business.trip_ids.includes(trip.id)"
            class="d-none d-md-inline-flex ml-5 ml-md-0 mr-md-6 mb-3 mb-md-6 px-7 py-4 body-1 border-radius-5 h-40 black"
            @click="toggleTrip(trip.id)"
            height="40px"
          >
            {{ trip.name }}
          </v-chip>

          <validation-provider
            class="mt-12"
            name="trips"
            rules="required"
            v-slot="{ errors }"
          >
            <input
              type="hidden"
              name="trips[]"
              v-model="request.business.trip_ids"
            />
            <div
              v-if="errors.length && request.business.trip_ids.length < 1"
              class="v-messages theme--light error--text"
              role="alert"
            >
              <div class="v-messages__wrapper">
                <div class="v-messages__message pl-5 pl-md-0 error-msg">
                  Please select at least one
                </div>
              </div>
            </div>
          </validation-provider>
        </div>
        <v-btn
          depressed
          block
          large
          color="primary"
          class="mb-2 mb-md-8 font-weight-bold darken-3 title"
          @click.prevent="step(-1)"
          :disabled="request.submitting"
        >
          Back
        </v-btn>
        <v-btn
          depressed
          block
          large
          color="primary"
          class="mb-8 font-weight-bold title"
          @click.prevent="$emit('submit')"
          :loading="request.submitting"
          :disabled="request.submitting"
        >
          Submit
        </v-btn>
      </div>
    </v-card>
  </validation-observer>
</template>

<script>
import RegistrationRequest from '@request/Auth/RegistrationRequest';
import userCrud from '@mixins/userCrud';

export default {
  name: 'OperatorRegistration',
  mixins: [userCrud],
  components: {
    LocationField: () => import('@components/utilities/LocationField'),
  },
  props: {
    request: {
      type: RegistrationRequest,
      required: true,
      default: () => {},
    },
  },
  methods: {
    async step(step = 1) {
      if (step < 1) {
        if (await this.request.validate()) {
          this.$emit('step', step);
        }
      }
    },
  },
  mounted() {
    this.getTrips();
  },
};
</script>

<style scoped></style>
